var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('console-layout', {
    attrs: {
      "width": "100%",
      "max-width": "1280"
    }
  }, [_c('console-title', [_c('span', [_vm._v("게시판 비방글 설정")])]), _c('console-search', {
    on: {
      "search": function search($event) {
        _vm.page = 1;

        _vm.search(true);
      }
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "3"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.searchKeys,
      "item-text": "text",
      "item-value": "value",
      "label": "검색조건",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    on: {
      "input": function input($event) {
        _vm.filter.searchValue = null;
      }
    },
    model: {
      value: _vm.filter.searchKey,
      callback: function callback($$v) {
        _vm.$set(_vm.filter, "searchKey", $$v);
      },
      expression: "filter.searchKey"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "검색어",
      "persistent-placeholder": "",
      "clearable": "",
      "hide-details": "",
      "disabled": !_vm.filter.searchKey
    },
    on: {
      "keydown": function keydown($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.page = 1;

        _vm.search(true);
      }
    },
    model: {
      value: _vm.filter.searchValue,
      callback: function callback($$v) {
        _vm.$set(_vm.filter, "searchValue", $$v);
      },
      expression: "filter.searchValue"
    }
  })], 1)], 1)], 1), _c('console-body', [_c('v-layout', {
    staticClass: "align-end"
  }, [_c('span', {
    staticClass: "subtitle-2"
  }, [_vm._v("검색수 : " + _vm._s(_vm.summary.totalCount.format()))]), _c('v-spacer'), _c('span')], 1), _c('v-data-table', {
    staticClass: "mt-2 elevation-1",
    attrs: {
      "items": _vm.configs,
      "headers": _vm.configsHeaders,
      "hide-default-footer": "",
      "disable-sort": "",
      "disable-pagination": ""
    },
    scopedSlots: _vm._u([{
      key: "item.actions",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_c('v-icon', {
          staticClass: "mx-1",
          attrs: {
            "small": ""
          },
          on: {
            "click": function click($event) {
              return _vm.edit(item);
            }
          }
        }, [_vm._v("mdi-pencil")])];
      }
    }], null, true)
  }), _c('v-pagination', {
    staticClass: "mt-3",
    attrs: {
      "length": _vm.pageCount,
      "total-visible": "11"
    },
    on: {
      "input": function input($event) {
        return _vm.search(true);
      }
    },
    model: {
      value: _vm.page,
      callback: function callback($$v) {
        _vm.page = $$v;
      },
      expression: "page"
    }
  })], 1), _c('v-btn', {
    attrs: {
      "fab": "",
      "fixed": "",
      "bottom": "",
      "right": "",
      "color": "accent",
      "to": "/console/board/configs/create"
    }
  }, [_c('v-icon', [_vm._v("mdi-pencil")])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }